import { Injectable } from "@angular/core";
import { DateTimeCellRendererComponent } from "../../renderers/date-time/date.time.component";

@Injectable({
  providedIn: 'root'
})

export class PreviosRunsColdef {
  constructor() { }

  public getColumnsDefinition(): any[] {
    return [
      {
        headerName: 'Output Folder',
        field: "lastOutputFolder",
        flex: 1,        
        headerCheckboxSelection: true,
        checkboxSelection: true,
        showDisabledCheckboxes: true,
        editable: false,
        wrapText: true,
        hide: true,
        rowGroup: true,
        sort: 'desc'
      },
      {
        headerName: 'Run Date',
        field: "lastOutputFolderDate",
        width: 100,
        flex: 1,
        cellRenderer: DateTimeCellRendererComponent,
        editable: false,
        wrapText: true,
        sort: 'desc'
      },
      {
        headerName: 'Model Status',
        field: "modelStatusDescription",
        width: 100,
        flex: 1,
        editable: false,
        wrapText: true,
      },
      {
        headerName: 'Models',
        field: "modelName",
        width: 150,
        flex: 1,
        resizable: true,
        editable: false,
        wrapText: true,
      },
    ];
  }
}